import { Swiper } from "swiper";
import type { SwiperOptions } from "swiper/types/swiper-options";
import { Autoplay, Pagination, Scrollbar, Navigation } from "swiper/modules";

export default class Slider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const $el = this as HTMLElement;
    const {
      slidetoshowMobile,
      slidetoshowDesktop,
      spacebetweenMobile,
      spacebetweenDesktop,
      centeredslidesMobile,
      centeredslidesDesktop,
      loopMobile,
      loopDesktop,
      autoplay,
      speed,
      delay,
    } = $el.dataset;
    const $elBullets = $el.querySelector<HTMLElement>(".swiper-pagination");
    const $elScrollbar = $el.querySelector<HTMLElement>(".swiper-scrollbar");
    const $elPrev = $el.querySelector<HTMLElement>(".swiper-button-prev");
    const $elNext = $el.querySelector<HTMLElement>(".swiper-button-next");

    if (!$el) {
      throw new Error("An element or dataset is missing");
    }

    // swiper options
    const swiperParams: SwiperOptions = {
      modules: [Autoplay, Pagination, Scrollbar, Navigation],
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: "auto",
          spaceBetween: 0,
          centeredSlides: false,
          loop: false,
        },
      },
    };

    // width settings
    if (slidetoshowMobile) {
      swiperParams.slidesPerView = Number(slidetoshowMobile);
    }
    if (
      slidetoshowDesktop &&
      swiperParams.breakpoints &&
      swiperParams.breakpoints[1024]
    ) {
      swiperParams.breakpoints[1024].slidesPerView = Number(slidetoshowDesktop);
    }

    // space between settings
    if (spacebetweenMobile) {
      swiperParams.spaceBetween = Number(spacebetweenMobile);
    }
    if (
      spacebetweenDesktop &&
      swiperParams.breakpoints &&
      swiperParams.breakpoints[1024]
    ) {
      swiperParams.breakpoints[1024].spaceBetween = Number(spacebetweenDesktop);
    }

    // centered slides settings@
    if (centeredslidesMobile === "true") {
      swiperParams.centeredSlides = true;
    }

    if (
      centeredslidesDesktop === "true" &&
      swiperParams.breakpoints &&
      swiperParams.breakpoints[1024]
    ) {
      swiperParams.breakpoints[1024].centeredSlides = true;
    }

    // loop settings
    if (loopMobile === "true") {
      swiperParams.loop = true;
    }

    if (loopDesktop === "true" && swiperParams.breakpoints) {
      swiperParams.breakpoints[1024].loop = true;
    }

    // autoplay settings
    if (autoplay === "true") {
      swiperParams.autoplay = {
        delay: 4000,
      };
    }

    // speed settings
    if (speed) {
      swiperParams.speed = Number(speed);
    }

    // delay settings
    if (delay) {
      swiperParams.autoplay = {
        delay: Number(delay),
      };
    }

    // pagination settings
    if ($elBullets) {
      swiperParams.pagination = {
        el: $elBullets,
        clickable: true,
      };
    }

    // scrollbar settings
    if ($elScrollbar) {
      swiperParams.scrollbar = {
        el: $elScrollbar,
      };
    }

    // navigation settings
    if ($elPrev && $elNext) {
      swiperParams.navigation = {
        nextEl: $elNext,
        prevEl: $elPrev,
      };
    }

    // swiper init
    new Swiper($el, swiperParams);
  }
}
